const updates = [
  {
    date: '2026-07-28',
    title: '《斗破苍穹》第426话更新',
    desc: '萧炎丹塔考核进入白热化阶段，三色异火融合震撼全场！全新炼药术揭示了远古斗帝的惊天秘密。',
    tag: '国漫更新',
  },
  {
    date: '2026-07-28',
    title: '《鬼灭之刃》无限城决战篇第218话',
    desc: '炭治郎与伙伴们深入无限城核心，面对最终BOSS鬼舞辻无惨，展开了赌上人类命运的最终战役。',
    tag: '日漫更新',
  },
  {
    date: '2026-07-27',
    title: '《我独自升级》济州岛篇第179话',
    desc: '成振宇率领暗影军团登陆济州岛，与蚁王展开惊天对决。暗影君主的最强形态震撼亮相！',
    tag: '韩漫更新',
  },
  {
    date: '2026-07-27',
    title: '平台新增《剑来》全集资源',
    desc: '陈平安的浩然江湖正式登陆古古漫画网！小镇少年的问剑之旅，细腻水墨画风不容错过。',
    tag: '新作入库',
  },
  {
    date: '2026-07-26',
    title: '《完美世界》第387话更新',
    desc: '石昊至尊骨大成，横推九天十地无人能挡！荒天帝的传奇之路再添浓墨重彩的一笔。',
    tag: '国漫更新',
  },
  {
    date: '2026-07-26',
    title: '《咒术回战》第254话更新',
    desc: '五条悟正式解封回归！史上最强咒术师再度降临，咒术界格局即将被彻底改写。',
    tag: '日漫更新',
  },
  {
    date: '2026-07-25',
    title: '下拉式阅读功能全面升级',
    desc: '优化滚动加载速度，新增夜间阅读模式与自定义字号功能，漫画大全阅读体验全面进化。',
    tag: '平台公告',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            漫画更新、新作入库、平台公告，不错过每一个精彩瞬间
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={`${item.date}-${idx}`}
              className="relative flex gap-4 pb-6 last:pb-0"
            >
              {/* Timeline */}
              <div className="flex flex-col items-center shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5"></div>
                {idx < updates.length - 1 && (
                  <div className="w-0.5 flex-1 bg-background-200 mt-2"></div>
                )}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0 pb-2">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}